'use strict';

const draftLifeTimeDays = 14;
module.exports.IN_DAYS = draftLifeTimeDays;
module.exports.IN_MS = draftLifeTimeDays * 24 * 3600 * 1000;
